module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('h2', {
    style: ({
      color: _vm.getCorpHeadingColor,
      textTransform: 'unset !important'
    })
  }, [_vm._v("Meet Our Experts and Hosts")]), _vm._v(" "), _c('div', {
    staticClass: "expertsrow"
  }, _vm._l((_vm.getAllExperts), function(expert) {
    return _c('div', {
      staticClass: "expert-entery",
      attrs: {
        "id": (expert.expertId * 115)
      }
    }, [_c('div', {
      staticClass: "expert_entry_holder",
      attrs: {
        "id": expert.expertId
      }
    }, [_c('div', {
      staticClass: "expert_entry_image-and-name-container"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": expert.small_image,
        "alt": expert.name,
        "title": expert.name
      }
    })]), _vm._v(" "), _c('h2', [_c('router-link', {
      attrs: {
        "to": {
          path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(expert.name) + "\n                                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(expert.experties))])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "expert_entry_datacontainer"
    }, [_c('h1', [_vm._v(_vm._s(expert.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(expert.experties))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(expert.areasofexpertise))]), _vm._v(" "), _c('router-link', {
      staticClass: "pink-button",
      attrs: {
        "to": {
          path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
        }
      }
    }, [_c('strong', [_vm._v("Find out More")])])], 1)])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "contactformtexttone contact-form"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/become-expert')
      }
    }
  }, [_c('h3', [_vm._v("Want to become a TONE Expert?")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67ddb66c", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ddb66c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Experts.vue